/**
 * POTENT POTIONS — Luxury Botanical Theme Interactions Script
 * Built with Vanilla JavaScript ES6 for maximum performance, 0 dependencies.
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initWishlist();
  initProductGallery();
  initMobileMenu();
  initScrollAnimations();
  initCartDrawer();
  initAjaxCart();
  initQuickView();
  initAccordions();
  initIngredientCards();
  initParallaxEffects();
  initSearchPopup();
});

function initMobileMenu() {
  const menu = document.getElementById('MobileNav');
  const toggle = document.querySelector('[data-action="open-mobile-nav"]');
  const backdrop = document.querySelector('.mobile-nav-backdrop');
  if (!menu || !toggle || !backdrop) return;
  const open = () => {
    menu.classList.add('is-open'); backdrop.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false'); toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    menu.classList.remove('is-open'); backdrop.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = document.querySelector('.wishlist-drawer.is-open') ? 'hidden' : '';
  };
  toggle.addEventListener('click', open);
  document.querySelectorAll('[data-action="close-mobile-nav"]').forEach((button) => button.addEventListener('click', close));
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  menu.querySelectorAll('[data-action="open-search"],[data-action="open-wishlist"]').forEach((button) => button.addEventListener('click', close));
  menu.querySelectorAll('.mobile-nav__accordion').forEach((item) => item.addEventListener('toggle', () => {
    if (!item.open) return;
    menu.querySelectorAll('.mobile-nav__accordion[open]').forEach((other) => { if (other !== item) other.removeAttribute('open'); });
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
}

function initProductGallery() {
  const main = document.getElementById('mainProductImage');
  const thumbs = [...document.querySelectorAll('[data-product-thumb]')];
  if (!main || !thumbs.length) return;
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    main.src = thumb.dataset.fullImage || thumb.src;
    thumbs.forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }));
  thumbs[0].classList.add('is-active');
}

function initWishlist() {
  const storageKey = 'potent-potions-wishlist';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (error) { saved = []; }
  const humanize = (value) => value.replace(/^potent-potions-/, '').replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  saved = saved.map((item) => typeof item === 'string' ? { key: item, title: humanize(item), url: `/products/${item}` } : item);

  const cardData = {};
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    cardData[button.dataset.productKey] = {
      key: button.dataset.productKey,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.variantId
    };
  });
  saved = saved.map((item) => ({ ...item, ...(cardData[item.key] || {}) }));

  const drawer = document.createElement('aside');
  drawer.className = 'wishlist-drawer';
  drawer.setAttribute('aria-label', 'Wishlist');
  drawer.innerHTML = '<div class="wishlist-drawer__header"><div><small>YOUR PRIVATE EDIT</small><h2>My Wishlist</h2></div><button class="wishlist-drawer__close" aria-label="Close wishlist">&times;</button></div><div class="wishlist-drawer__items"></div><div class="wishlist-drawer__footer"><a href="/collections/all" class="btn-primary"><span>Continue Shopping</span></a></div>';
  const backdrop = document.createElement('button');
  backdrop.className = 'wishlist-backdrop';
  backdrop.setAttribute('aria-label', 'Close wishlist');
  document.body.append(backdrop, drawer);
  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (error) {}
  };
  const updateCount = () => document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
    count.textContent = saved.length;
    count.hidden = saved.length === 0;
  });
  const renderDrawer = () => {
    const list = drawer.querySelector('.wishlist-drawer__items');
    list.innerHTML = saved.length ? saved.map((item) => `<article class="wishlist-item">${item.image ? `<a href="${item.url || '#'}" class="wishlist-item__image"><img src="${item.image}" alt=""></a>` : ''}<div class="wishlist-item__details"><small>BOTANICAL FORMULATION</small><a href="${item.url || '#'}" class="wishlist-item__title">${item.title || humanize(item.key)}</a>${item.price ? `<strong>${item.price}</strong>` : ''}<div class="wishlist-item__actions">${item.variantId ? `<button type="button" data-wishlist-add="${item.variantId}">Add to cart</button>` : ''}<button type="button" data-wishlist-remove="${item.key}">Remove</button></div></div></article>`).join('') : '<div class="wishlist-empty"><span>♡</span><h3>Your edit awaits</h3><p>Save formulations you would like to revisit.</p></div>';
    updateCount();
  };
  renderDrawer();

  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const key = button.dataset.productKey;
    const render = () => {
      const active = saved.some((item) => item.key === key);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'product'} ${active ? 'from' : 'to'} wishlist`);
    };
    render();
    button.addEventListener('click', () => {
      saved = saved.some((item) => item.key === key)
        ? saved.filter((item) => item.key !== key)
        : [...saved, cardData[key]];
      persist();
      render();
      renderDrawer();
    });
  });
  const closeDrawer = () => { drawer.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; };
  const openDrawer = () => { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  document.querySelectorAll('[data-action="open-wishlist"]').forEach((button) => button.addEventListener('click', openDrawer));
  drawer.querySelector('.wishlist-drawer__close').addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    const add = event.target.closest('[data-wishlist-add]');
    if (add && window.PotentPotions?.addVariant) {
      closeDrawer();
      window.PotentPotions.addVariant(add.dataset.wishlistAdd, 1, add);
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (!remove) return;
    saved = saved.filter((item) => item.key !== remove.dataset.wishlistRemove);
    persist(); renderDrawer();
    document.querySelector(`[data-wishlist-button][data-product-key="${remove.dataset.wishlistRemove}"]`)?.classList.remove('is-active');
  });
}

/* 1. Header Scroll Logic */
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* 2. Reveal on Scroll Observer */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.reveal-on-scroll');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
}

/* 3. Cart Drawer */
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('DrawerOverlay');

  if (!drawer || !overlay) return;

  const openDrawer = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  // Delegated so re-rendered drawer content keeps working after AJAX updates
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]')) openDrawer(e);
    else if (e.target.closest('[data-action="close-cart"]')) closeDrawer();
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  window.PotentPotions = window.PotentPotions || {};
  window.PotentPotions.openCart = openDrawer;
  window.PotentPotions.closeCart = closeDrawer;
}

/* 4. Quick View Modal */
function initQuickView() {
  const modal = document.getElementById('QuickViewModal');
  const overlay = document.getElementById('DrawerOverlay');
  const quickViewBtns = document.querySelectorAll('[data-action="quick-view"]');

  if (!modal) return;

  const qvAddBtn = modal.querySelector('#QuickViewAdd');
  const qvLink = modal.querySelector('#QuickViewLink');

  quickViewBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const productTitle = btn.getAttribute('data-product-title') || 'Luxury Botanical Elixir';
      const productPrice = btn.getAttribute('data-product-price') || '₹1,850';
      const productImage = btn.getAttribute('data-product-image');
      const productSub = btn.getAttribute('data-product-sub') || 'Pure Organic Extract';
      const productIngr = btn.getAttribute('data-product-ingr') || 'Kashmiri Saffron, Sandalwood, Kumkumadi Oil';
      const productUrl = btn.getAttribute('data-product-url') || '#';
      const variantId = btn.getAttribute('data-variant-id') || '';
      const available = btn.getAttribute('data-available') !== 'false';

      modal.querySelector('.qv-title').textContent = productTitle;
      modal.querySelector('.qv-price').textContent = productPrice;
      modal.querySelector('.qv-sub').textContent = productSub;
      modal.querySelector('.qv-ingredients').textContent = productIngr;
      if (productImage) {
        modal.querySelector('.qv-image').src = productImage;
      }
      if (qvLink) qvLink.href = productUrl;
      if (qvAddBtn) {
        qvAddBtn.dataset.variantId = variantId;
        qvAddBtn.disabled = !available || !variantId;
        qvAddBtn.querySelector('span').textContent = available ? 'Add to Ritual Cart' : 'Sold Out';
      }

      modal.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  if (qvAddBtn) {
    qvAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = qvAddBtn.dataset.variantId;
      if (!variantId) return;
      // Close the quick view, then add so the cart drawer is the focus
      modal.classList.remove('active');
      if (window.PotentPotions && window.PotentPotions.addVariant) {
        window.PotentPotions.addVariant(variantId, 1, qvAddBtn);
      }
    });
  }

  const closeBtn = modal.querySelector('[data-action="close-qv"]');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
}

/* 5. Accordion Components */
function initAccordions() {
  const accordions = document.querySelectorAll('.accordion-header');
  accordions.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const content = item.querySelector('.accordion-content');
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.accordion-item.open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.accordion-content').style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('open');
        content.style.maxHeight = null;
      } else {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* 6. Ingredient Experience Interactive Cards */
function initIngredientCards() {
  const cards = document.querySelectorAll('.ingredient-card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      cards.forEach(c => c.classList.remove('featured'));
      card.classList.add('featured');
    });
  });
}

/* 7. Parallax Effects */
function initParallaxEffects() {
  const parallaxBg = document.querySelector('.hero-parallax-bg');
  if (!parallaxBg) return;

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    parallaxBg.style.transform = `translateY(${scrolled * 0.25}px)`;
  }, { passive: true });
}

/* 8. Search Popup & Predictive Botanical Search */
function initSearchPopup() {
  const popup = document.getElementById('SearchPopup');
  const trigger = document.querySelectorAll('[data-action="open-search"]');
  const close = document.querySelectorAll('[data-action="close-search"]');
  const form = document.getElementById('SearchPopupForm');
  const input = document.getElementById('SearchPopupInput') || document.querySelector('.search-popup-input');
  const resultsContainer = document.getElementById('SearchPopupResults');
  const popularWrapper = document.getElementById('SearchPopularWrapper');
  const popularTags = document.querySelectorAll('.popular-search-tag');

  if (!popup) return;

  const openSearch = () => {
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      if (input) input.focus();
    }, 150);
  };

  const closeSearch = () => {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  };

  trigger.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  }));

  close.forEach(btn => btn.addEventListener('click', closeSearch));

  popup.addEventListener('click', (e) => {
    if (e.target === popup) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('active')) {
      closeSearch();
    }
  });

  if (!input) return;

  let debounceTimeout;
  const performSearch = (term) => {
    const q = (term !== undefined ? term : input.value || '').trim();
    if (!q) {
      if (resultsContainer) resultsContainer.innerHTML = '';
      if (popularWrapper) popularWrapper.style.display = 'block';
      return;
    }

    if (resultsContainer) {
      resultsContainer.innerHTML = '<div class="search-results-loading">Seeking Pure Formulations...</div>';
    }

    const suggestUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';
    const fetchUrl = `${suggestUrl}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;

    fetch(fetchUrl)
      .then(res => res.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          if (resultsContainer) {
            resultsContainer.innerHTML = `
              <div class="search-results-empty">
                <p>No formulations found matching "<strong>${escapeHtml(q)}</strong>".</p>
                <div style="margin-top: 1.25rem;">
                  <button type="submit" form="SearchPopupForm" class="search-results-view-all-btn">Search Full Catalog &rarr;</button>
                </div>
              </div>
            `;
          }
          return;
        }

        let html = '<div class="search-results-grid">';
        products.forEach(p => {
          const imgUrl = p.featured_image ? (p.featured_image.url || p.featured_image) : 'https://images.unsplash.com/photo-1608248597260-657d65445e54?q=80&w=400';
          const price = p.price ? formatMoney(p.price) : '';
          html += `
            <a href="${p.url}" class="search-result-card">
              <div class="search-result-card__image-box">
                <img src="${imgUrl}" alt="${escapeHtml(p.title)}" class="search-result-card__image" loading="lazy" width="220" height="220">
              </div>
              <div class="search-result-card__info">
                <span class="search-result-card__title">${escapeHtml(p.title)}</span>
                ${price ? `<span class="search-result-card__price">${price}</span>` : ''}
              </div>
            </a>
          `;
        });
        html += '</div>';

        html += `
          <div class="search-results-view-all">
            <button type="submit" form="SearchPopupForm" class="search-results-view-all-btn">
              View All Results For "${escapeHtml(q)}" &rarr;
            </button>
          </div>
        `;

        if (resultsContainer) resultsContainer.innerHTML = html;
      })
      .catch(err => {
        console.warn('Predictive search fallback error:', err);
        if (resultsContainer) {
          resultsContainer.innerHTML = `
            <div class="search-results-view-all">
              <button type="submit" form="SearchPopupForm" class="search-results-view-all-btn">
                Search For "${escapeHtml(q)}" &rarr;
              </button>
            </div>
          `;
        }
      });
  };

  input.addEventListener('input', () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => performSearch(input.value), 250);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const q = (input.value || '').trim();
      if (q && form) {
        form.submit();
      }
    }
  });

  popularTags.forEach(pill => {
    pill.addEventListener('click', () => {
      const term = pill.getAttribute('data-search-term') || pill.textContent.trim();
      input.value = term;
      performSearch(term);
      input.focus();
    });
  });

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[m]);
  }

  function formatMoney(centsOrNum) {
    if (typeof centsOrNum === 'string' && (centsOrNum.includes('₹') || centsOrNum.includes('Rs'))) {
      return centsOrNum;
    }
    const num = parseFloat(centsOrNum);
    if (isNaN(num)) return '';
    const val = num > 5000 && Number.isInteger(num) ? (num / 100).toFixed(0) : Math.round(num);
    return `₹${val.toLocaleString('en-IN')}`;
  }
}

/* 9. AJAX Cart — add / update / remove without page reload */
function initAjaxCart() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  window.PotentPotions = window.PotentPotions || {};
  window.PotentPotions.addVariant = (id, qty, btn) => submitAdd(id, qty || 1, btn);

  // Intercept add-to-cart submits (product cards, product page, mobile bar)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const isCardForm = form.matches('[data-product-card-form]');
    const isProductForm = form.id === 'product-form';
    if (!isCardForm && !isProductForm) return;

    // On the product page, let "Buy Now" (name="checkout") post normally
    if (isProductForm && e.submitter && e.submitter.name === 'checkout') return;

    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    const btn = e.submitter || form.querySelector('[type="submit"]');
    submitAdd(idInput.value, qty, btn);
  });

  // Quantity +/- and remove inside the drawer (event delegation survives re-render)
  drawer.addEventListener('click', (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const key = item.getAttribute('data-key');
    const qtyEl = item.querySelector('[data-qty]');
    const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

    if (e.target.closest('[data-cart-plus]')) {
      changeCart(key, current + 1);
    } else if (e.target.closest('[data-cart-minus]')) {
      changeCart(key, current - 1);
    } else if (e.target.closest('[data-cart-remove]')) {
      changeCart(key, 0);
    }
  });
}

function submitAdd(variantId, quantity, btn) {
  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  if (btn) btn.classList.add('is-loading');

  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json().then(data => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      if (!ok || data.status) {
        flashButton(btn, data.description || 'Unavailable', true);
        return;
      }
      if (data.sections && data.sections['cart-drawer']) {
        replaceDrawer(data.sections['cart-drawer']);
        syncCountFromDrawer();
        if (window.PotentPotions.openCart) window.PotentPotions.openCart();
      } else {
        refreshDrawer(true);
      }
      flashButton(btn, 'Added ✓', false);
    })
    .catch(() => flashButton(btn, 'Try again', true));
}

/* Fallback: fetch the cart drawer section directly, then optionally open it */
function refreshDrawer(open) {
  fetch('?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
    .then(res => res.json())
    .then(data => {
      if (data && data['cart-drawer']) {
        replaceDrawer(data['cart-drawer']);
        syncCountFromDrawer();
        if (open && window.PotentPotions.openCart) window.PotentPotions.openCart();
      }
    })
    .catch(() => {});
}

function changeCart(key, quantity) {
  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
  const drawer = document.getElementById('CartDrawer');
  if (drawer) drawer.classList.add('is-loading');

  fetch(changeUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.sections && data.sections['cart-drawer']) {
        replaceDrawer(data.sections['cart-drawer']);
      }
      if (typeof data.item_count === 'number') {
        updateCartCount(data.item_count);
      } else {
        syncCountFromDrawer();
      }
    })
    .finally(() => {
      const d = document.getElementById('CartDrawer');
      if (d) d.classList.remove('is-loading');
    });
}

/* Replace drawer inner HTML while preserving the outer element + open state */
function replaceDrawer(html) {
  const current = document.getElementById('CartDrawer');
  if (!current) return;
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const fresh = tmp.querySelector('#CartDrawer');
  current.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
}

/* Read the authoritative item count from the freshly rendered drawer */
function syncCountFromDrawer() {
  const label = document.querySelector('#CartDrawer [data-cart-count-label]');
  if (!label) return;
  const match = label.textContent.match(/\d+/);
  updateCartCount(match ? parseInt(match[0], 10) : 0);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function flashButton(btn, message, isError) {
  if (!btn) return;
  btn.classList.remove('is-loading');
  const span = btn.querySelector('span') || btn;
  const original = btn.dataset.originalLabel || span.textContent;
  btn.dataset.originalLabel = original;
  span.textContent = message;
  if (!isError) btn.classList.add('is-added');
  setTimeout(() => {
    span.textContent = original;
    btn.classList.remove('is-added');
  }, 1600);
}
